module.exports = __webpack_public_path__ + "img/nomade-communication.48083967.png";